import { render, staticRenderFns } from "./TaskTag.vue?vue&type=template&id=3b3e2bb6&scoped=true"
import script from "./TaskTag.vue?vue&type=script&lang=js"
export * from "./TaskTag.vue?vue&type=script&lang=js"
import style0 from "./TaskTag.vue?vue&type=style&index=0&id=3b3e2bb6&prod&lang=scss"
import style1 from "./TaskTag.vue?vue&type=style&index=1&id=3b3e2bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3e2bb6",
  null
  
)

export default component.exports